module.exports = {
  messages: {
    CN: {
      SelectSubscriptionPlan: "选择订阅版本",
      BillingInformation: "订单详情",
      Payment: "支付",
      lastName: "姓",
      firstName: "名",
      SaveChanges: "保存更改",
      billInfo: "付费详情",
      TotalCost: "总费用",
      CompanyName: "公司",
      CompanySize: "规模",
      Country: "国家",
      City: "城市",
      ZIPCode: "邮政编码",
      Address: "地址",
      Back: "返回",
      NextStep: "下一步",
      OrderSummary: "订单",
      OriginalPrice: "原价",
      Discount: "优惠",
      Total: "总计",

      EnterPaymentDetails: "信用卡详情",
      CardNumber: "卡号",
      ExpirationDate: "过期时间",
      SecurityCode: "安全码",
      Subscribe: "订阅",

      SubscriptionPlan: "订阅版本",
      lite: "精简版",
      pro: "专业版",
      prime: "至尊版",
      BillingCycle: "支付周期",
      MonthlyPayment: "按月支付",
      AnnualPayment: "按年支付",
      Botselection: "机器人选择",
      AISalesRep: "AI销售代表",
      AIRecruiter: "AI招聘专员",
      SetasDefault: "设为默认",
      TotalPrice: "总价",
      BillingInformations: "计费信息",
      AddBillingInformation: "新增计费信息",
      EditBillingInformation: "修改计费信息",
      EnterCompanyName: "请输入公司的名称",
      SelectCountry: "请选择国家",
      EnterCityName: "请填写城市",
      EnterZipCode: "请正确输入邮政编码",
      EnterAddress: "请填写地址",
      Save: "保存",
      Cancel: "取消",
      SelectCardNumber: "请选择一个卡号",
      DoyoudiscountCode: "是否有折扣码",
      discountCodeOnce: "每个折扣码只可以使用一次",
      codeExpired: "折扣码已过期",
      AddaNew: "添加新卡",
      Enter: "请输入",
      ExpirationDateFormat: "有效期请输入MM/YY格式",
      InvalidCardExpirationDate: "卡有效期不正确",
      CardExpirationDate: "卡有效期已过",
      EnterValidCVCCode: "请正确输入CVC码",
      Order: "订单",
      Purchase: "订阅",
      OrderHistory: "订单历史",
      OrderDate: "订单日期",
      SubscriptionType: "订阅方式",
      Price: "价格",
      LinkAccount: "绑定账号",
      GotoLinkAccount: "去绑定",
      ExclusiveDiscountCode: "专属折扣码",
      ValidityPeriod: "有效期",
      Discount2: "折扣",
      TotalUses: "总次数",
      RemainingUses: "剩余次数",
      CommissionManagement: "返佣管理",
      ID: "ID",
      SubscriptionDate: "订阅日期",
      CommissionDate: "返佣日期",
      FullyRefunded: "暂停返佣，已返还全部",
      UserRefunded: "暂停返佣，用户已退款",
      DiscountedPrice: "优惠价格",
      FinalPaidAmount: "实付价格",
      CommissionEligible: "是否返佣",
      Yes: "是",
      No: "无",
      ExpectedCommission: "应返佣金",
      PaidCommission: "已返佣金",
      PendingCommission: "待返佣金",
      LastName: "姓",
      FirstName: "名",
      pleaseEnterLastName: "请输入姓",
      enterFirstName: "请输入名",
      enterEmail: "请输入邮箱",
      validEmail: "请填写正确的邮箱",
      validPhone: "电话号码请输入数字",
      phoneNumber: "电话",
      name: "姓名",
      Email: "邮箱",
      EnterDiscountCode: "请输入折扣码",
      selectBillingInformation: "请选择计费信息",
      saveInfo: "请完善保存计费信息后再继续下一步",
      orderInfo: "订单信息",
      freeTrialTips:
        "账号已过试用期，所有的任务都已暂停，想要继续使用strategyBrain,请订阅",

      // plan
      Monthly: "月付",
      Annually: "年付(83折)",
      Allfeatures: "AI销售代表和AI招聘官的全部功能",
      AllcoreAIRecruiter: "AI招聘官的核心功能",
      ReducecostsandImprove: "AI助力您大幅提高效率并降低成本",
      ExploreourPlatform: "10天免费试用全部功能",
      ChooseEitherAISale100: `<span style='color:#6caba3'>选择AI销售代表或AI招聘官</span>，套餐包含添加40个好友和100次对话`,
      ChooseEitherAISale500: `<span style='color:#6caba3'>选择AI销售代表或AI招聘官</span>，套餐包含添加120个好友和500次对话`,
      GainunlimitedAccess:
        "无限使用所有<span style='color:#6caba3'>AI销售代表和AI招聘官的功能</span>，包括无限添加好友",
      FirstWeek: "10天",
      day: "天",
      paidMonthly: "按月付费",
      paidAnnually: "按年付费",
      BestSeller: "热销",
      Purchase1: "支付",
      Sales: "销售代表",
      Recruiter: "招聘官",
      AIselection: "AI功能选择",
      CoreFeature: "核心功能",
      Campaign: "任务",
      SearchResults: "搜索列表",
      ConnectionRequest: "好友请求",
      Connection: "好友",
      Conversation: "对话",
      DashBoard: "看板",
      HRExpert: "AI人力专家",
      AllcorefeaturesofAISalesRep: "AI销售代表的所有核心功能",
      Partiallysupported: "部分支持",
      Notsupported: "不支持",
      Fullysupported: "全部支持",
      Unlimited: "无限",
      "40hoursofworkperweek": "每周工作40小时：",
      ClientsAndCandidatesNeed: "人工搜索客户和候选人并添加好友",
      EachClientAndCandidate: "每位客户和候选人都需要人工进行个性化沟通",
      DelayedresponsesMakeTimely: "回复延迟使得及时跟进客户变得困难",
      litePlanDes: `您可以选择 <span style='color:#6caba3'>AI销售代表 或 AI招聘官</span>，套餐包含添加40个好友额度，年付仅需 99美元。`,
      proPlanDes: `您可以选择 <span style='color:#6caba3'>AI销售代表 或 AI招聘官</span>，套餐包含添加120个好友额度，年付仅需 399美元。`,
      primePlanDes: `您可以使用 <span style='color:#6caba3'>AI销售代表 和 AI招聘官 的全部功能</span>，并享受无限添加好友额度，年付仅799美元。`,
      FreeTrial: "免费版",
      Manual: "人工",
      LitePlan: "精简版",
      ProPlan: "专业版",
      PrimePlan: "至尊版",
      year: "年",
      month: "月",
      NoStrategyBrain: "无StrategyBrain",
      updateSuccessTxt: "保存成功",
      ContinueConnect: "继续绑定账号",
      PurchaseMethod: "购买方式",

      CreateCampaign: "创建推广活动",
      Chooseplan: "选择套餐",
      invoiceInformation: "账单和发票信息",
      Choosetheright: "选择适合您的支付套餐",
      publishyourcampaign:
        "要发布您的推广活动，请选择一个支付套餐。我们提供灵活的定价选项，帮助您实现业务目标。",
      Guarantee: "10天退款保证",
      instanthelp:
        "不满意？10天内获得全额退款。请联系 info@strategybrain.com 或在线聊天寻求即时帮助。",
      besetSeller: "最多人买",
      landTips: "基于LinkedIn账户限制的规定。",
      monthly2: "月",
      Bindyourcreditcard:
        "绑定信用卡即可继续享受所有功能。可随时取消，无需任何费用。",
      Continuetrial: "继续试用",
      Aftertrialends:
        "*试用结束后，将自动按每月19.9美元的价格为您续订精简版套餐。",
      Bindcard: "绑定卡片并继续试用",
      campaignscheduled: "您有一条campaign已排期。",
      Topublishit: "如需发布，请绑定信用卡继续使用免费版，或升级至付费套餐。",
      GotoPublish: "前往发布",
      fourMoth: "4个月超长无忧退款保证",
      Notsatisfied: `对效果不满意？4个月内为您提供全额退款。请发送邮件至 info@strategybrain.com 或使用在线即时聊天获取帮助。`,
      Termsandconditionsapply: "适用条款说明：",
      Aleast10campaigns: "需成功创建并运行至少10个活动",
      Atleasttwocampaigns: "其中至少2项活动持续运行30天或以上",
      Noleadsweregenerated: `未产生任何潜在客户（本条款中"潜在客户"由AI定义为展现兴趣的潜在客户群体，包含多次互动但最终未成交的意向用户，不仅限于获取联系信息）`,
      Thispolicyapplies:
        "本政策仅适用于通过StrategyBrain官网直接购买的产品。通过折扣活动、促销活动、特价优惠或终身会员套餐渠道购买的产品不参与本退款保证",
      Proxycoverage: "代理覆盖范围:55个国家",
      Languagesupport: "语言支持:100个国家",
      AIConversationTuning: "AI对话调优:包含",
      SimulatedConversationTesting: "模拟对话测试:包含",
      AIRequirementsAnalysis: "AI需求分析:包含",
      EnterprisePlan: "企业版计划",
      Seamlesslyboost:
        "通过AI无缝提升企业效率，驱动低成本增长。立即联系我们，开启高效之旅。",
      ChooseYourTeamSize: "选择团队规模",
      Starter: "入门版",
      Growth: "成长版",
      Scale: "规模版",
      Enterprise: "企业版",
      accounts: "*个账号",
      popular: "热门",
      Corefeature: "核心功能：",
      AllFeaturesIncluded: "包含个人版全部功能",
      EnterpriseTraining: "企业培训与专家支持",
      EnterpriseSingle: "企业单点登录（SSO）",
      AccessManagement: "访问管理集成",
      AccesstoDesignated: "指定AI模型使用权",
      UnlimitedConnectionRequests: "无限次连接请求 ",
      UnlimitedConnections: "无限连接数",
      APIAccess: "API接口访问",
      AuditLogs: "审计日志与操作日志",
      LinkedInAccess: "通过195个国家代理IP访问领英 ",
      MultilingualAICommunication: "支持256种语言的多语种AI沟通",
      LocalizationofSystem: "系统界面本地化 ",
      CustomizedBusiness: "定制化商业智能报告",
      TeamManagement: "团队管理与角色权限设置 ",
      Availableadd: "可用增值服务：",
      Warmup: "账号预热/验证",
      ProxyPool: "代理/IP池",
      Rolebasedpermissions: "角色权限管理 ",
      Audittrail: "审计追踪",
      Contactus: "联系我们",
      ShowAllFeatures: "显示所有功能▼",
      ShowLess: "显示更少▲",

      // LinkedIn Account Manager
      LinkedInAccountManager: "LinkedIn 账号管理器",
      ManageDailyLimits:
        "管理每个 LinkedIn 账号的每日限额、分配模式和推广活动执行顺序。",
      SelectLinkedInAccount: "选择 LinkedIn 账号",
      Campaigns: "个活动",
      AccountSettings: "账号设置",
      DailyConnectionRequestLimit: "每日连接请求限额",
      requestsPerDay: "请求/天",
      SentToday: "今日已发送",
      Remaining: "剩余",
      AllocationMode: "分配模式",
      CampaignExecutionQueue: "活动执行队列",
      DragToReorder: "拖动以重新排序执行优先级",
      Queue: "队列",
      CampaignName: "活动名称",
      Agent: "代理",
      Active: "启用",
      TodaysPlan: "今日计划",
      Created: "创建时间",
      Only: "仅剩",
      leftToComplete: "个待完成",
      from: "来自",
      today: "今日",
      SurplusFrom: "剩余来自",
      WaitingInQueue: "队列等待中",
      SaveSuccess: "保存成功",
      SequentialExecutionNotice: "顺序执行通知",
      SequentialNoticeContent1: "在此模式下，只有",
      SequentialNoticeContent2: "正在积极运行。活动 #2 和 #3 正在排队等待，",
      SequentialNoticeContent3: "直到前一个活动完成才会开始",
      SequentialNoticeContent4:
        "。如果活动 #1 有很多联系人，等待时间可能是几天甚至几周。",
      SequentialNoticeTip:
        "提示：拖动活动以重新排序优先级，或切换到「平均分配」以同时运行所有活动。",
      needed: "所需",
      Done: "已完成",
      AISalesRepLabel: "AI 销售代表",
      AIRecruiterLabel: "AI 招聘师",
      OnlyLeftToComplete: "仅剩 {count} 个待完成",
      fromCampaign: "来自活动 #",
      EqualExecutionNotice: "平均执行通知",
      EqualNoticeContent:
        "在此模式下，所有活动将同时运行，每日限额将在各活动之间平均分配。",
      PendingCrawl: "等待抓取",
      DayLimit: "每日限额",
      RemainingToday: "今日剩余",
      UsedToday: "今日已用",
      SwitchModeTips:
        "切换模式后，请务必点击右上角的「保存更改」按钮，使更改生效。",
      LTDAccountTips:
        "LTD账户可以创建多个活动，但同一时间只能激活一个。不支持同时运行多个活动。因此，此选项在LTD版本中已隐藏。",
      Invoice: "发票",
      InvoiceNo: "发票号",
      InvoiceDate: "日期",
      InvoicePlan: "套餐",
      InvoiceAmount: "金额",
      InvoiceDownload: "下载",
      InvoiceFree: "免费",
      CompleteInfo:"请完善发票信息，才可以继续下载！",
      PlanStepCreateCampaign: "创建任务",
      PlanStepActivatePay: "激活并支付",
      PlanStepEnterBilling: "填写账单信息",
      PlanStepCardAdded: "已添加银行卡",
      PlanMatchedCustomers: "位客户",
      PlanMatchedCandidates: "位候选人",
      PlanLaunchBanner: "您即将启动：<strong>\"{campaignName}\"</strong> <span class=\"dot-sep\">·</span> <strong>{count} {matchedLabel}</strong> <span class=\"dot-sep\">·</span> 首批回复约 <strong class=\"text-green\">1-3 天，20+</strong> 意向候选人/月。在下方激活，让 AI 开始工作。",
      PlanGuaranteeBanner: "<strong>30 天无理由退款保障 ——</strong> 不满意？30 天内可全额退款，或随时联系客服 / 在线支持。",
      PlanToggleTrial: "免费试用（10 天）",
      PlanToggleRecommended: "推荐",
      PlanToggleDirect: "直接购买套餐",
      PlanNewUsersBanner: "<strong>仅限新用户：</strong>添加银行卡即可开始 <strong class=\"text-green\">10 天免费试用；</strong>第 10 天才首次扣费（每个账户限一次试用）。",
      PlanTrialTitle: "开始 10 天免费试用 —— 今日 $0",
      PlanTrialIntro: "添加支付方式即可<strong>立即启动</strong>，让 AI 开始联系您的 240 位目标潜在客户。<strong>前 10 天 $0，第 10 天才首次扣费，在此之前可随时一键取消</strong>。",
      PlanTrialFeature1: "<strong>前 10 天 $0</strong> —— 第 10 天只有您满意才扣费",
      PlanTrialFeature2: "<strong>随时一键取消</strong>（阻止下一次扣费；当前周期继续有效）",
      PlanTrialFeature3: "<strong>到期前 2 天邮件提醒</strong> —— 绝无意外扣费",
      PlanTrialFeature4: "<strong>30 天无理由退款保障</strong>",
      PlanDueToday: "今日应付",
      PlanActivatedOnceCard: "添加银行卡后即激活",
      PlanFullAccess: "<strong>完全访问，无任何限制</strong> —— 任务 / 连接 / 对话 / 潜在客户搜索均不限量，包含 Dashboard 及全部 AI HR Expert 功能。",
      PlanRenewNote: "试用结束后默认按 <strong class=\"text-green\">Lite 月付 ${amount}/月</strong> 自动续费；可随时更换套餐或取消 <span class=\"dot-sep\">·</span> <span class=\"renew-emoji\">&#127873;</span> 首次扣费日为 <strong>{chargeDate}</strong>（第 10 天）—— 在此之前取消则无需支付任何费用。",
      PlanNextBtn: "下一步",
      PlanSkipLink: "已确定长期使用？<strong>直接购买套餐（跳过试用）</strong> <span class=\"skip-arrow\">&rarr;</span>",
      PlanFreeTrialNote: "免费试用仅限首次使用的客户。",
    },

    US: {
      SelectSubscriptionPlan: "Select Subscription Plan",
      BillingInformation: "Billing Information",
      Payment: "Payment",
      lastName: "Last Name",
      firstName: "First Name",
      SaveChanges: "Save Changes",
      billInfo: "Billing Information and Payment Details",
      TotalCost: "Total Cost",
      CompanyName: "Company Name",
      CompanySize: "Company Size",
      Country: "Country",
      City: "City",
      ZIPCode: "ZIP Code",
      Address: "Address",
      Back: "Back",
      NextStep: "Next Step",
      OrderSummary: "Order Summary",
      OriginalPrice: "Original Price",
      Discount: "Discount",
      Total: "Total",

      EnterPaymentDetails: "Enter Payment Details",
      CardNumber: "Card Number",
      ExpirationDate: "Expiration Date",
      SecurityCode: "Security Code",
      Subscribe: "Subscribe",

      SubscriptionPlan: "Subscription Plan",
      lite: "lite",
      pro: "pro",
      prime: "prime",
      BillingCycle: "Billing Cycle",
      MonthlyPayment: "Monthly Payment",
      AnnualPayment: "Annual Payment",
      Botselection: "Bot selection",
      AISalesRep: "AI Sales Rep",
      AIRecruiter: "AI Recruiter",
      SetasDefault: "Set as Default",
      TotalPrice: "Total Price",
      BillingInformations: "Billing Information",
      AddBillingInformation: "Add Billing Information",
      EditBillingInformation: "Edit Billing Information",
      EnterCompanyName: "Enter Company Name",
      SelectCountry: "Select Country",
      EnterCityName: "Enter City Name",
      EnterZipCode: "Enter a Valid Zip Code",
      EnterAddress: "Enter Address",
      Save: "Save",
      Cancel: "Cancel",
      SelectCardNumber: "Select a Card Number",
      DoyoudiscountCode: "Do you have a discount code",
      discountCodeOnce: "Each account can only use a discount code once",
      codeExpired: "Discount code has expired",
      AddaNew: "Add a new",
      Enter: "Enter",
      ExpirationDateFormat: "Expiration Date (MM/YY)",
      InvalidCardExpirationDate: "Invalid Card Expiration Date",
      CardExpirationDate: "Card Expiration Date Has Passed",
      EnterValidCVCCode: "Enter a Valid CVC Code",
      Order: "Order",
      Purchase: "Purchase",
      OrderHistory: "Order History",
      OrderDate: "Order Date",
      SubscriptionType: "Subscription Type",
      Price: "Price",
      LinkAccount: "Link Account",
      GotoLinkAccount: "Go to Link Account",
      ExclusiveDiscountCode: "Exclusive Discount Code",
      ValidityPeriod: "Validity Period",
      Discount2: "Discount",
      TotalUses: "Total Uses",
      RemainingUses: "Remaining Uses",
      CommissionManagement: "Commission Management",
      ID: "ID",
      SubscriptionDate: "Subscription Date",
      CommissionDate: "Commission Date",
      FullyRefunded: "Commission Paused, Fully Refunded",
      UserRefunded: "Commission Paused, User Refunded",
      DiscountedPrice: "Discounted Price",
      FinalPaidAmount: "Final Paid Amount",
      CommissionEligible: "Commission Eligible",
      Yes: "Yes",
      No: "No",
      ExpectedCommission: "Expected Commission",
      PaidCommission: "Paid Commission",
      PendingCommission: "Pending Commission",
      LastName: "Last Name",
      FirstName: "First Name",
      pleaseEnterLastName: "please enter Last Name",
      enterFirstName: "Please enter First Name",
      enterEmail: "Please enter an Email",
      validEmail: "Please enter a valid email ",
      validPhone: "Phone number must contain only digits",
      phoneNumber: "Phone Number",
      name: "Name",
      Email: "Email",
      EnterDiscountCode: "Enter Discount Code",
      selectBillingInformation: "Please select billing information",
      saveInfo:
        "Please complete and save billing information before proceeding to the next step",
      orderInfo: "Order Details",
      freeTrialTips:
        "Your account's trial period has expired, all tasks have been paused. To continue using StrategyBrain, please subscribe",

      // plan
      Monthly: "Monthly",
      Annually: "Annually(17% OFF)",
      Allfeatures: "All features of AI Sales Rep and AI Recruiter",
      AllcoreAIRecruiter: "All core features of AI Recruiter",
      ReducecostsandImprove:
        "Reduce costs and improve efficiency significantly with AI assistance.",
      ExploreourPlatform: "Explore our platform with a free 10-day trial.",
      ChooseEitherAISale100: `Choose either <span style="color:#6caba3">AI Sales Rep or AI Recruiter</span>, which includes 40 connections and 100 conversations.`,
      ChooseEitherAISale500: `Choose either <span style="color:#6caba3">AI Sales Rep or AI Recruiter</span>, which includes 120 connections and 500 conversations.`,
      GainunlimitedAccess: `Gain unlimited access to all <span style="color:#6caba3">AI Sales Rep and AI Recruiter features</span>, including unlimited connections.`,
      FirstWeek: "10 days",
      day: "day",
      paidMonthly: "Paid monthly",
      paidAnnually: "Paid annually",
      BestSeller: "Best Seller",
      Purchase1: "Purchase",
      Sales: "Sales",
      Recruiter: "Recruiter",
      AIselection: "AI selection",
      CoreFeature: "Core Feature",
      Campaign: "Campaign",
      SearchResults: "Search Results",
      ConnectionRequest: "Connection request",
      Connection: "Connection",
      Conversation: "Conversation",
      DashBoard: "DashBoard",
      HRExpert: "AI HR Expert",
      AllcorefeaturesofAISalesRep: "All core features of AI Sales Rep",
      Partiallysupported: "Partially supported",
      Notsupported: "Not supported",
      Fullysupported: "Fully supported",
      Unlimited: "Unlimited",
      "40hoursofworkperweek": "40 hours of work per week.",
      ClientsAndCandidatesNeed:
        "Clients and candidates need to be manually sourced and added.",
      EachClientAndCandidate:
        "Each client and candidate requires personalized, one-on-one manual communication.",
      DelayedresponsesMakeTimely:
        "Delayed responses make timely follow-up challenging.",
      litePlanDes: `You can choose either <span style="color:#6caba3">AI Sales Rep or AI Recruiter</span>, which includes 40 connections, for an annually fee of US$99.`,
      proPlanDes: `You can choose either <span style="color:#6caba3">AI Sales Rep or AI Recruiter</span>, which includes 120 connections, for an annually fee of US$399.`,
      primePlanDes: `You can use all features of both <span style="color:#6caba3">AI Sales Rep and AI Recruiter</span> with unlimited connections for US$799 per year.`,
      FreeTrial: "Free Trial",
      Manual: "Manual",
      LitePlan: "Lite Plan",
      ProPlan: "Pro Plan",
      PrimePlan: "Prime Plan",
      year: "year",
      month: "month",
      NoStrategyBrain: "No StrategyBrain",
      updateSuccessTxt: "Save successful",
      ContinueConnect: "Continue Link Your LinkedIn Account",
      PurchaseMethod: "Purchase Method",

      CreateCampaign: "Create campaign",
      Chooseplan: "Choose a plan",
      invoiceInformation: "Billing & invoice Information",
      Choosetheright: "Choose the right payment plan for you",
      publishyourcampaign:
        "To publish your campaign, please select a payment plan. We offer flexible pricing options to help you achieve your business goals.",
      Guarantee: "10-Day Money-Back Guarantee",
      instanthelp:
        "Not satisfied? Get a full refund within 10 days. Contact info@strategybrain.com or live chat for instant help.",
      besetSeller: "Best seller",
      landTips: "Limitation based on LinkedIn account restriction.",
      monthly2: "monthly",
      Bindyourcreditcard:
        "Bind your credit card to continue enjoying all features. You can cancel anytime without any charges.",
      Continuetrial: "Continue trial",
      Aftertrialends:
        "*After the trial ends, you will be automatically charged for the Lite Plan at $19.9 per month.",
      Bindcard: "Bind card and continue trial",
      campaignscheduled: "You have a campaign scheduled.",
      Topublishit:
        "To publish it, please add your credit card to continue using the free plan, or upgrade to a paid plan.",
      GotoPublish: "Go to Publish",
      fourMoth: "4-Month Money-Back Guarantee ",
      Notsatisfied:
        "Not satisfied? Get a full refund within 4 months. Contact info@strategybrain.com or live chat for instant help.",
      Termsandconditionsapply: "Terms and conditions apply：",
      Aleast10campaigns:
        "At least 10 campaigns must have been successfully created and run.",
      Atleasttwocampaigns:
        "At least two campaigns must have run for 30 days or longer.",
      Noleadsweregenerated: `No leads were generated. (A "lead" is defined by AI as a potential customer showing interest, which may include repeated interactions even if they decline, not limited to contact information.）`,
      Thispolicyapplies:
        "This policy applies only to products purchased directly from the StrategyBrain official website. Products sold as part of discounts, promotions, special offers, or LTD (Lifetime Deal) are excluded.",
      Proxycoverage: "Proxy coverage: 55 countries ",
      Languagesupport: "Language support: 100 countries ",
      AIConversationTuning: "AI Conversation Tuning: Included ",
      SimulatedConversationTesting: "Simulated Conversation Testing: Included ",
      AIRequirementsAnalysis: "AI Requirements Analysis: Included",
      EnterprisePlan: "Enterprise Plan",
      Seamlesslyboost:
        "Seamlessly boost your enterprise efficiency with AI and drive low-cost growth. Contact us today.",
      ChooseYourTeamSize: "Choose Your Team Size",
      Starter: "Starter ",
      Growth: "Growth",
      Scale: "Scale",
      Enterprise: "Enterprise",
      accounts: "* accounts",
      popular: "popular",
      Corefeature: "Core feature：",
      AllFeaturesIncluded: "All Features Included in Personal Plan",
      EnterpriseTraining: "Enterprise Training & Expert Support",
      EnterpriseSingle: "Enterprise Single Sign-On (SSO) ",
      AccessManagement: "Access Management Integration",
      AccesstoDesignated: "Access to Designated AI Models",
      UnlimitedConnectionRequests: "Unlimited Connection Requests",
      UnlimitedConnections: "Unlimited Connections",
      APIAccess: "API Access",
      AuditLogs: "Audit Logs and Operational Logs",
      LinkedInAccess: "LinkedIn Access via Proxy IPs in 195 Countries",
      MultilingualAICommunication:
        "Multilingual AI Communication Supporting 256 Languages",
      LocalizationofSystem: "Localization of System UI",
      CustomizedBusiness: "Customized Business Intelligence Reports",
      TeamManagement: "Team Management and Role-Based Permissions",
      Availableadd: "Available add-ons：",
      Warmup: "Warm-up / Verify",
      ProxyPool: "Proxy / IP pool",
      Rolebasedpermissions: "Role-based permissions",
      Audittrail: "Audit trail",
      Contactus: "Contact us ",
      ShowAllFeatures: "Show All Features ▼",
      ShowLess: "Show Less  ▲",

      // LinkedIn Account Manager
      LinkedInAccountManager: "LinkedIn Account Manager",
      ManageDailyLimits:
        "Manage daily limits, allocation modes, and campaign execution order for each LinkedIn account.",
      SelectLinkedInAccount: "Select LinkedIn Account",
      Campaigns: "Campaigns",
      AccountSettings: "Account Settings",
      DailyConnectionRequestLimit: "Daily Connection Request Limit",
      requestsPerDay: "requests / day",
      SentToday: "Sent Today",
      Remaining: "Remaining",
      AllocationMode: "Allocation Mode",
      CampaignExecutionQueue: "Campaign Execution Queue",
      DragToReorder: "Drag to reorder execution priority",
      Queue: "Queue",
      CampaignName: "Campaign Name",
      Agent: "Agent",
      Active: "Active",
      TodaysPlan: "Today's Plan",
      Created: "Created",
      Only: "Only",
      leftToComplete: "left to complete",
      from: "from",
      today: "today",
      SurplusFrom: "Surplus from",
      WaitingInQueue: "Waiting in queue",
      SaveSuccess: "Changes saved successfully",
      SequentialExecutionNotice: "Sequential Execution Notice",
      SequentialNoticeContent1: "In this mode, only ",
      SequentialNoticeContent2:
        " is actively running. Campaigns #2 and #3 are waiting in line and ",
      SequentialNoticeContent3:
        "will not start until the previous campaign completes",
      SequentialNoticeContent4:
        ". If Campaign #1 has many contacts, the waiting time could be days or even weeks.",
      SequentialNoticeTip:
        "Tip: Drag campaigns to reorder priority, or switch to 'Equal Distribution' to run all campaigns simultaneously.",
      needed: "needed",
      Done: "Done",
      AISalesRepLabel: "AI Sales Rep",
      AIRecruiterLabel: "AI Recruiter",
      OnlyLeftToComplete: "Only {count} left to complete",
      fromCampaign: "from campaign #",
      EqualExecutionNotice: "Equal Execution Notice",
      EqualNoticeContent:
        "In this mode, all campaigns will run simultaneously, with daily limits distributed evenly across them.",
      PendingCrawl: "Pending crawl",
      DayLimit: "Day Limit",
      RemainingToday: "Remaining Today",
      UsedToday: "Used Today",
      SwitchModeTips:
        'After switching modes, be sure to click "Save changes" in the top right corner for the changes to take effect.',
      LTDAccountTips:
        "LTD accounts can create multiple campaigns, but only one can be active at a time. Simultaneous running of multiple campaigns is not supported. Therefore, this option is hidden for LTD versions.",
      Invoice: "Invoice",
      InvoiceNo: "Invoice No",
      InvoiceDate: "Date",
      InvoicePlan: "Plan",
      InvoiceAmount: "Amount",
      InvoiceDownload: "Download",
      InvoiceFree: "Free",
      CompleteInfo:"Please complete the invoice information before continuing to download. ",
      PlanStepCreateCampaign: "Create campaign",
      PlanStepActivatePay: "Activate & pay",
      PlanStepEnterBilling: "Enter billing info",
      PlanStepCardAdded: "Card added",
      PlanMatchedCustomers: "customers",
      PlanMatchedCandidates: "candidates",
      PlanLaunchBanner: "You're about to launch: <strong>\"{campaignName}\"</strong> <span class=\"dot-sep\">&middot;</span> <strong>{count} {matchedLabel}</strong> <span class=\"dot-sep\">&middot;</span> first replies in <strong class=\"text-green\">~1-3 days, 20+</strong> interested candidates/month. Activate below to put AI to work.",
      PlanGuaranteeBanner: "<strong>30-day money-back guarantee &mdash;</strong> not happy? Get a full refund within 30 days, or reach support / live chat anytime.",
      PlanToggleTrial: "Free trial (10 days)",
      PlanToggleRecommended: "Recommended",
      PlanToggleDirect: "Buy a plan directly",
      PlanNewUsersBanner: "<strong>New users only:</strong> add a card to start your <strong class=\"text-green\">10-day free trial;</strong> first charge is on day 10 (one trial per account).",
      PlanTrialTitle: "Start your 10-day free trial &mdash; $0 today",
      PlanTrialIntro: "Add a payment method to <strong>launch right away</strong> and let AI start contacting your 240 target prospects. <strong>$0 for 10 days, first charge on day 10, cancel anytime before then</strong> with one click.",
      PlanTrialFeature1: "<strong>$0 for 10 days</strong> &mdash; you're only billed on day 10 if you're happy",
      PlanTrialFeature2: "<strong>Cancel anytime in one click</strong> (stops the next charge; current period stays active)",
      PlanTrialFeature3: "<strong>Email reminder 2 days before it ends</strong> &mdash; never a surprise charge",
      PlanTrialFeature4: "<strong>30-day money-back guarantee</strong>",
      PlanDueToday: "Due today",
      PlanActivatedOnceCard: "Activated once your card is added",
      PlanFullAccess: "<strong>Full access, no limits</strong> &mdash; unlimited campaigns / connections / conversations / prospect searches, including Dashboard and all AI HR Expert features.",
      PlanRenewNote: "After the trial it auto-renews at <strong class=\"text-green\">Lite monthly ${amount}/mo</strong> by default; change plan or cancel anytime <span class=\"dot-sep\">&middot;</span> <span class=\"renew-emoji\">&#127873;</span> first charge on <strong>{chargeDate}</strong> (day 10) &mdash; cancel before then and pay nothing.",
      PlanNextBtn: "Next",
      PlanSkipLink: "Already sure you'll stay long-term? <strong>Buy a plan directly (skip the trial)</strong> <span class=\"skip-arrow\">&rarr;</span>",
      PlanFreeTrialNote: "Free trials are for first-time customers only.",
    },
    AR: {
      SelectSubscriptionPlan: "اختر خطة الاشتراك",
      BillingInformation: "معلومات الفوترة",
      Payment: "الدفع",
      lastName: "اللقب",
      firstName: "الاسم الأول",
      SaveChanges: "حفظ التغييرات",
      billInfo: "معلومات الفوترة وتفاصيل الدفع",
      TotalCost: "التكلفة الإجمالية",
      CompanyName: "اسم الشركة",
      CompanySize: "حجم الشركة",
      Country: "البلد",
      City: "المدينة",
      ZIPCode: "الرمز البريدي",
      Address: "العنوان",
      Back: "العودة",
      NextStep: "التالي",
      OrderSummary: "ملخص الطلب",
      OriginalPrice: "السعر الأصلي",
      Discount: "الخصم",
      Total: "الإجمالي",
      EnterPaymentDetails: "أدخل تفاصيل الدفع",
      CardNumber: "رقم البطاقة",
      ExpirationDate: "تاريخ الانتهاء",
      SecurityCode: "الرمز الأمني",
      Subscribe: "اشترك",
      SubscriptionPlan: "خطة الاشتراك",
      lite: "الخطة الأساسية",
      pro: "الخطة الاحترافية",
      prime: "الخطة الأساسية الممتازة",
      BillingCycle: "دورة الفوترة",
      MonthlyPayment: "الدفع الشهري",
      AnnualPayment: "الدفع السنوي",
      Botselection: "اختيار الروبوت:",
      AISalesRep: "ممثل المبيعات بالذكاء الاصطناعي",
      AIRecruiter: "موظف التوظيف بالذكاء الاصطناعي",
      SetasDefault: "تعيين كافتراضي",
      TotalPrice: "السعر الإجمالي",
      BillingInformations: "معلومات الفوترة",
      AddBillingInformation: "إضافة معلومات الفوترة",
      EditBillingInformation: "تعديل معلومات الفوترة",
      EnterCompanyName: "أدخل اسم الشركة",
      SelectCountry: "اختر الدولة",
      EnterCityName: "أدخل اسم المدينة",
      EnterZipCode: "يرجى إدخال رمز بريدي صالح",
      EnterAddress: "أدخل العنوان",
      Save: "حفظ",
      Cancel: "إلغاء",
      SelectCardNumber: "اختر رقم البطاقة",
      DoyoudiscountCode: "هل لديك رمز خصم",
      discountCodeOnce: "يمكن لكل حساب استخدام رمز خصم مرة واحدة فقط",
      codeExpired: "انتهت صلاحية رمز الخصم",
      AddaNew: "أضف جديدًا",
      Enter: "أدخل",
      ExpirationDateFormat: "تاريخ انتهاء الصلاحية (MM/YY)",
      InvalidCardExpirationDate: "تاريخ انتهاء صلاحية البطاقة غير صالح",
      CardExpirationDate: "انتهت صلاحية البطاقة",
      EnterValidCVCCode: "يرجى إدخال رمز CVC صالح",
      Order: "الطلب",
      Purchase: "شراء",
      OrderHistory: "سجل الطلبات",
      OrderDate: "تاريخ الطلب",
      SubscriptionType: "نوع الاشتراك",
      Price: "السعر",
      LinkAccount: "ربط الحساب",
      GotoLinkAccount: "اذهب إلى ربط الحساب",
      ExclusiveDiscountCode: "رمز خصم حصري",
      ValidityPeriod: "فترة الصلاحية",
      Discount2: "الخصم",
      TotalUses: "إجمالي عدد مرات الاستخدام",
      RemainingUses: "عدد مرات الاستخدام المتبقية",
      CommissionManagement: "إدارة العمولات",
      ID: "ID",
      SubscriptionDate: "تاريخ الاشتراك",
      CommissionDate: "تاريخ العمولة",
      FullyRefunded: "تم إيقاف العمولة، وتم استرداد المبلغ بالكامل",
      UserRefunded: "تم إيقاف العمولة، وتم استرداد المبلغ للمستخدم",
      DiscountedPrice: "السعر المخفض",
      FinalPaidAmount: "المبلغ المدفوع النهائي",
      CommissionEligible: "مؤهل للحصول على العمولة",
      Yes: "نعم",
      No: "لا",
      ExpectedCommission: "العمولة المتوقعة",
      PaidCommission: "العمولة المدفوعة",
      PendingCommission: "العمولة المعلقة",
      LastName: "اللقب",
      FirstName: "الاسم الأول",
      pleaseEnterLastName: "أدخل اسم العائلة",
      enterFirstName: "أدخل الاسم الأول",
      enterEmail: "أدخل البريد الإلكتروني",
      validEmail: "يُرجى إدخال البريد الإلكتروني الصحيح",
      validPhone: "يُرجى إدخال أرقام فقط في حقل رقم الهاتف",
      phoneNumber: "الهاتف",
      name: "الاسم",
      Email: "البريد الإلكتروني",
      EnterDiscountCode: "يُرجى إدخال رمز الخصم",
      selectBillingInformation: "يرجى اختيار معلومات الفوترة",
      saveInfo:
        "يُرجى إكمال وحفظ معلومات الفوترة قبل المتابعة إلى الخطوة التالية",
      orderInfo: "معلومات الطلب",
      freeTrialTips:
        "انتهت فترة تجربة الحساب، وتم إيقاف جميع المهام. إذا كنت ترغب في الاستمرار في استخدام StrategyBrain، يرجى الاشتراك",
      // plan
      Monthly: "شهريًا",
      Annually: "سنويًا (خصم 17%)",
      Allfeatures: "جميع ميزات المبيعات والتوظيف",
      AllcoreAIRecruiter: " جميع الميزات الأساسية لأداة التوظيف",
      ReducecostsandImprove:
        "قلل التكاليف وحسّن الكفاءة بشكل كبير بمساعدة الذكاء الاصطناعي.",
      ExploreourPlatform: "استكشف منصتنا مع فترة تجريبية مجانية لمدة 10 أيام.",
      ChooseEitherAISale100: `اختر <span style='color:#6caba3'>إما روبوت المبيعات أو روبوت التوظيف</span>، والذي يشمل 40 اتصالًا و100 محادثة.`,
      ChooseEitherAISale500: `اختر <span style='color:#6caba3'>إما روبوت المبيعات أو روبوت التوظيف</span>، والذي يشمل 120 اتصالًا و500 محادثة.`,
      GainunlimitedAccess: `احصل على وصول غير محدود إلى جميع ميزات <span style="color:#6caba3">روبوت المبيعات وروبوت التوظيف</span>، بما في ذلك الاتصالات غير المحدودة.`,
      FirstWeek: "عشرة أيا",
      day: "يوم",
      paidMonthly: "تُدفع شهريًا",
      paidAnnually: "تُدفع سنويًا",
      BestSeller: "الأكثر مبيعًا",
      Purchase1: " شراء",
      Sales: "المبيعات",
      Recruiter: "مسؤول التوظيف",
      AIselection: "اختيار الذكاء الاصطناعي",
      CoreFeature: "الميزة الأساسية",
      Campaign: "الحملة",
      SearchResults: "قائمة البحث عن الأشخاص",
      ConnectionRequest: "طلب الاتصال",
      Connection: "الاتصالات",
      Conversation: "المحادثة",
      DashBoard: "لوحة التحكم",
      HRExpert: "خبير الموارد البشرية",
      AllcorefeaturesofAISalesRep: "جميع الميزات الأساسية لممثل المبيعات",
      Partiallysupported: "مدعوم جزئيًا",
      Notsupported: "غير مدعومة",
      Fullysupported: "مدعوم بالكامل",
      Unlimited: "غير محدودة",
      "40hoursofworkperweek": "٤٠ ساعة عمل أسبوعيًا.",
      ClientsAndCandidatesNeed:
        "يحتاج العملاء والمرشحون إلى البحث اليدوي والإضافة يدويًا.",
      EachClientAndCandidate:
        "يتطلب كل عميل ومرشح تواصلًا يدويًا فرديًا وشخصيًا.",
      DelayedresponsesMakeTimely:
        "تجعل الردود المتأخرة المتابعة في الوقت المناسب أمرًا صعبًا.",
      litePlanDes: `يمكنك اختيار <span style="color:#6caba3">إما المبيعات أو التوظيف</span>، والذي يشمل 40 اتصالًا، مقابل رسوم سنوية قدرها 99 دولارًا أمريكيًا`,
      proPlanDes: `يمكنك اختيار <span style="color:#6caba3">إما المبيعات أو التوظيف</span>، والذي يشمل 120 اتصالًا، مقابل رسوم سنوية قدرها 399 دولارًا أمريكيًا.`,
      primePlanDes: `يمكنك استخدام جميع ميزات <span style="color:#6caba3">كل من المبيعات والتوظيف</span> مع اتصالات غير محدودة مقابل 799 دولارًا أمريكيًا سنويًا. `,
      FreeTrial: "نسخة تجريبية مجانية",
      Manual: "يدوي",
      LitePlan: "الخطة الأساسية",
      ProPlan: "الخطة الاحترافية",
      PrimePlan: "الخطة الأساسية الممتازة",
      year: "دولار",
      month: "شهريًا",
      NoStrategyBrain: "بدون StrategyBrain",
      updateSuccessTxt: "حفظ بنجاح ",
      ContinueConnect: "استمر في ربط حسابك على LinkedIn",
      PurchaseMethod: "طريقة الشراء",
      CreateCampaign: "إنشاء حملة",
      Chooseplan: "اختيار خطة",
      invoiceInformation: "معلومات الفواتير والفاتورة",
      Choosetheright: "اختر خطة الدفع المناسبة لك",
      publishyourcampaign:
        "لنشر حملتك، يرجى تحديد خطة دفع. نحن نقدم خيارات تسعير مرنة لمساعدتك على تحقيق أهداف عملك.",
      Guarantee: "ضمان استعادة الأموال لمدة 10 يومًا",
      instanthelp:
        "غير راضٍ؟ احصل على استرداد كامل في غضون 10 يومًا. اتصل بـ info@strategybrain.com أو الدردشة المباشرة للحصول على مساعدة فورية.",
      besetSeller: "الأكثر مبيعًا",
      landTips: "تقييد بناءً على قيود حساب LinkedIn.",
      monthly2: "شهرياً",
      Bindyourcreditcard:
        "اربط بطاقتك الائتمانية لمواصلة الاستمتاع بجميع الميزات. يمكنك الإلغاء في أي وقت دون أي رسوم.",
      Continuetrial: "مواصلة التجربة",
      Aftertrialends:
        "*بعد انتهاء الفترة التجريبية، سيتم تجديد اشتراكك تلقائياً في الخطة الأساسية مقابل 19.9 دولار شهرياً.",
      Bindcard: "ربط البطاقة ومتابعة التجربة",
      campaignscheduled: "لديك حملة مجدولة.",
      Topublishit:
        "لنشرها، يرجى إضافة بطاقتك الائتمانية لمواصلة استخدام الخطة المجانية، أو الترقية إلى خطة مدفوعة.",
      GotoPublish: "انتقل إلى النشر",
      fourMoth: "ضمان استرجاع الأموال لمدة 4 أشهر",
      Notsatisfied:
        "غير راضٍ؟ احصل على استرداد كامل خلال 4 أشهر. اتصل على info@strategybrain.com أو الدردشة المباشرة للحصول على مساعدة فورية.",
      Termsandconditionsapply: "الشروط والأحكام:",
      Aleast10campaigns: "يجب إنشاء وتشغيل 10 حملات على الأقل بنجاح",
      Atleasttwocampaigns:
        "يجب أن تستمر حملتان على الأقل في التشغيل لمدة 30 يومًا أو أكثر",
      Noleadsweregenerated: `عدم تحقيق أي عملاء محتملين
(يُعرّف "العميل المحتمل" بأنه عميل محتمل يظهر اهتمامًا، وقد يشمل تفاعلات متكررة حتى في حال الرفض، دون حصر ذلك في معلومات الاتصال)`,
      Thispolicyapplies: `تطبق هذه السياسة فقط على المنتجات المشتراة مباشرة من الموقع الرسمي لـ StrategyBrain.
لا تشمل المنتجات المباعة ضمن عروض الخصم أو الترويج أو العروض الخاصة أو صفقات الشراء مدى الحياة.`,
      Proxycoverage: "التغطية عبر الوكلاء: 55 دولة",
      Languagesupport: "الدعم اللغوي: 100 دولة",
      AIConversationTuning: "ضبط محادثات الذكاء الاصطناعي: مُضمن",
      SimulatedConversationTesting: "اختبار المحادثات المحاكاة: مُضمن",
      AIRequirementsAnalysis: "تحليل متطلبات الذكاء الاصطناعي: مُضمن",
      EnterprisePlan: "باقة المؤسسة",
      Seamlesslyboost:
        "عزز كفاءة مؤسستك بسلاسة باستخدام الذكاء الاصطناعي وحقق نمواً منخفض التكلفة. اتصل بنا اليوم.",
      ChooseYourTeamSize: "اختر حجم فريقك:",
      Starter: "المبتدئ",
      Growth: "النمو",
      Scale: "التوسع",
      Enterprise: "المؤسسة",
      accounts: "* حسابات",
      popular: "الأكثر شيوعاً",
      Corefeature: "الميزات الأساسية:",
      AllFeaturesIncluded: "جميع المميزات المضمنة في الباقة الشخصية",
      EnterpriseTraining: "تدريب مؤسسي ودعم خبراء",
      EnterpriseSingle: "دخول موحد للمؤسسة (SSO)",
      AccessManagement: "تكامل إدارة الوصول",
      AccesstoDesignated: "الوصول إلى نماذج الذكاء الاصطناعي المخصصة",
      UnlimitedConnectionRequests: "طلبات اتصال غير محدودة",
      UnlimitedConnections: "اتصالات غير محدودة",
      APIAccess: "وصول إلى واجهة البرمجة (API)",
      AuditLogs: "سجلات التدقيق والسجلات التشغيلية",
      LinkedInAccess: "الوصول إلى لينكدإن عبر وكيل IP في 195 دولة",
      MultilingualAICommunication: "اتصال ذكي متعدد اللغات يدعم 256 لغة",
      LocalizationofSystem: "توطين واجهة النظام",
      CustomizedBusiness: "تقارير ذكاء أعمال مخصصة",
      TeamManagement: "إدارة الفريق والأذونات القائمة على الأدوار",
      Availableadd: "الإضافات المتاحة:",
      Warmup: "الإحماء / التحقق",
      ProxyPool: "الوكيل / مجموعة IP",
      Rolebasedpermissions: "أذونات قائمة على الأدوار",
      Audittrail: "سجل التدقيق",
      Contactus: "اتصل بنا",
      ShowAllFeatures: " ▼ إظهار جميع الميزات",
      ShowLess: " ▲ إظهار أقل",

      // LinkedIn Account Manager
      LinkedInAccountManager: "مدير حساب LinkedIn",
      ManageDailyLimits:
        "إدارة الحدود اليومية وأوضاع التخصيص وترتيب تنفيذ الحملات لكل حساب LinkedIn",
      SelectLinkedInAccount: "اختر حساب LinkedIn",
      Campaigns: "حملات",
      AccountSettings: "إعدادات الحساب",
      DailyConnectionRequestLimit: "الحد الأقصى لطلبات الاتصال اليومية",
      requestsPerDay: "طلب / يوم",
      SentToday: "تم الإرسال اليوم",
      Remaining: "متبقي",
      AllocationMode: "وضع التخصيص",
      CampaignExecutionQueue: "قائمة انتظار تنفيذ الحملات",
      DragToReorder: "اسحب لإعادة ترتيب أولوية التنفيذ",
      Queue: "قائمة الانتظار",
      CampaignName: "اسم الحملة",
      Agent: "الوكيل",
      Active: "نشط",
      TodaysPlan: "خطة اليوم",
      Created: "تم الإنشاء",
      Only: "فقط",
      leftToComplete: "متبقي لإكمالها",
      from: "من",
      today: "اليوم",
      SurplusFrom: "فائض من",
      WaitingInQueue: "في انتظار قائمة الانتظار",
      SaveSuccess: "تم حفظ التغييرات بنجاح",
      SequentialExecutionNotice: "إشعار التنفيذ التسلسلي",
      SequentialNoticeContent1: "في هذا الوضع، فقط ",
      SequentialNoticeContent2:
        " يعمل بنشاط. الحملات #2 و #3 في انتظار قائمة الانتظار و ",
      SequentialNoticeContent3: "لن تبدأ حتى تكتمل الحملة السابقة",
      SequentialNoticeContent4:
        ". إذا كانت الحملة #1 تحتوي على العديد من جهات الاتصال، فقد يكون وقت الانتظار أيامًا أو حتى أسابيع.",
      SequentialNoticeTip:
        "نصيحة: اسحب الحملات لإعادة ترتيب الأولوية، أو قم بالتبديل إلى 'التوزيع المتساوي' لتشغيل جميع الحملات في نفس الوقت.",
      needed: "مطلوب",
      Done: "تم",
      AISalesRepLabel: "مندوب مبيعات AI",
      AIRecruiterLabel: "مسؤول توظيف AI",
      OnlyLeftToComplete: "فقط {count} متبقي للإكمال",
      fromCampaign: "من الحملة #",
      EqualExecutionNotice: "إشعار التنفيذ المتساوي",
      EqualNoticeContent:
        "في هذا الوضع، ستعمل جميع الحملات في وقت واحد، مع توزيع الحدود اليومية بالتساوي بينها.",
      PendingCrawl: "في انتظار الزحف",
      DayLimit: "الحد اليومي",
      RemainingToday: "المتبقي اليوم",
      UsedToday: "المستخدم اليوم",
      SwitchModeTips:
        'بعد تبديل الأوضاع، تأكد من النقر على "حفظ التغييرات" في الزاوية العلوية اليمنى لتصبح التغييرات سارية المفعول.',
      LTDAccountTips:
        "يمكن لحسابات LTD إنشاء حملات متعددة، ولكن يمكن تفعيل حملة واحدة فقط في كل مرة. لا يُدعم تشغيل حملات متعددة في وقت واحد. لذلك، تم إخفاء هذا الخيار في إصدار LTD.",
      Invoice: "الفاتورة",
      InvoiceNo: "رقم الفاتورة",
      InvoiceDate: "التاريخ",
      InvoicePlan: "الخطة",
      InvoiceAmount: "المبلغ",
      InvoiceDownload: "تنزيل",
      InvoiceFree: "مجاني",
      CompleteInfo:"يُرجى إكمال معلومات الفاتورة للمتابعة في التنزيل.",
      PlanStepCreateCampaign: "إنشاء الحملة",
      PlanStepActivatePay: "التفعيل والدفع",
      PlanStepEnterBilling: "إدخال معلومات الفوترة",
      PlanStepCardAdded: "تمت إضافة البطاقة",
      PlanMatchedCustomers: "عملاء",
      PlanMatchedCandidates: "مرشحين",
      PlanLaunchBanner: "أنت على وشك إطلاق: <strong>\"{campaignName}\"</strong> <span class=\"dot-sep\">·</span> <strong>{count} {matchedLabel}</strong> <span class=\"dot-sep\">·</span> أول الردود خلال <strong class=\"text-green\">~1-3 أيام، 20+</strong> مرشح مهتم/شهريًا. فعّل أدناه ليبدأ الذكاء الاصطناعي العمل.",
      PlanGuaranteeBanner: "<strong>ضمان استرداد الأموال لمدة 30 يومًا —</strong> غير سعيد؟ احصل على استرداد كامل خلال 30 يومًا، أو تواصل مع الدعم / الدردشة المباشرة في أي وقت.",
      PlanToggleTrial: "تجربة مجانية (10 أيام)",
      PlanToggleRecommended: "موصى به",
      PlanToggleDirect: "شراء خطة مباشرة",
      PlanNewUsersBanner: "<strong>للمستخدمين الجدد فقط:</strong> أضف بطاقة لبدء <strong class=\"text-green\">تجربتك المجانية لمدة 10 أيام؛</strong> أول عملية خصم في اليوم العاشر (تجربة واحدة لكل حساب).",
      PlanTrialTitle: "ابدأ تجربتك المجانية لمدة 10 أيام — $0 اليوم",
      PlanTrialIntro: "أضف وسيلة دفع <strong>للإطلاق فورًا</strong> ودع الذكاء الاصطناعي يبدأ التواصل مع 240 عميلًا محتملًا مستهدفًا. <strong>$0 لمدة 10 أيام، أول خصم في اليوم العاشر، يمكنك الإلغاء في أي وقت قبل ذلك</strong> بنقرة واحدة.",
      PlanTrialFeature1: "<strong>$0 لمدة 10 أيام</strong> — لن يتم خصم أي مبلغ إلا في اليوم العاشر إذا كنت سعيدًا",
      PlanTrialFeature2: "<strong>الإلغاء في أي وقت بنقرة واحدة</strong> (يوقف الخصم التالي؛ الفترة الحالية تبقى سارية)",
      PlanTrialFeature3: "<strong>تذكير بالبريد الإلكتروني قبل يومين من الانتهاء</strong> — لا مفاجآت في الفوترة أبدًا",
      PlanTrialFeature4: "<strong>ضمان استرداد الأموال لمدة 30 يومًا</strong>",
      PlanDueToday: "المستحق اليوم",
      PlanActivatedOnceCard: "يُفعّل بمجرد إضافة بطاقتك",
      PlanFullAccess: "<strong>وصول كامل بلا حدود</strong> — حملات / اتصالات / محادثات / عمليات بحث غير محدودة، بما في ذلك لوحة التحكم وجميع ميزات AI HR Expert.",
      PlanRenewNote: "بعد التجربة، يتم التجديد التلقائي افتراضيًا بخطة <strong class=\"text-green\">Lite الشهرية ${amount}/شهر</strong>؛ غيّر الخطة أو ألغِ في أي وقت <span class=\"dot-sep\">·</span> <span class=\"renew-emoji\">&#127873;</span> أول خصم في <strong>{chargeDate}</strong> (اليوم العاشر) — ألغِ قبل ذلك ولا تدفع شيئًا.",
      PlanNextBtn: "التالي",
      PlanSkipLink: "متأكد أنك ستبقى على المدى الطويل؟ <strong>اشترِ خطة مباشرة (تجاوز التجربة)</strong> <span class=\"skip-arrow\">&rarr;</span>",
      PlanFreeTrialNote: "التجارب المجانية متاحة للعملاء الجدد فقط.",
    },
  },
};
